import { render, staticRenderFns } from "./orderDetailRefundDetail.vue?vue&type=template&id=32d7a616&scoped=true"
import script from "./orderDetailRefundDetail.vue?vue&type=script&lang=js"
export * from "./orderDetailRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetailRefundDetail.vue?vue&type=style&index=0&id=32d7a616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7a616",
  null
  
)

export default component.exports